import { OutlinedInput } from "@/components/form/input/OutlinedInput";
import { Button, FormControl, FormLabel, FormHelperText as MuiFormHelperText, Stack } from "@mui/material";
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from "formik";
import { useSnackbar } from "notistack";
import { useOutletContext } from "react-router-dom";
import * as yup from "yup";
import { projectApi } from "../../../../../api/projectApi";

const initialValues = {
    benefit: "",
};

const validationSchema = yup.object().shape({
    benefit: yup.string().nullable(),
});

function createInitialValues(project) {
    return {
        ...initialValues,
        benefit: project?.benefit,
    };
}

function FormHelperText({ name, touched, errors, ...restProps }) {
    return (
        <MuiFormHelperText error={touched[name] && !!errors[name]} {...restProps}>
            <ErrorMessage name={name} />
        </MuiFormHelperText>
    );
}

export default function BenefitForm(props) {
    const { project } = useOutletContext();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [updateProjectSettingInfo] = projectApi.endpoints.updateProjectSettingInfo.useMutation();

    const handleOnSubmit = async (values, formikBag) => {
        // call mutation
        const snackbarAction = (snackbarId) => <Button onClick={() => closeSnackbar(snackbarId)}>Close</Button>;
        let notifyMessage = null;
        try {
            const result = await updateProjectSettingInfo({
                projectId: project?.id,
                ...values,
            }).unwrap();
            console.log(result);
            notifyMessage = result.data?.message ?? "update success";
        } catch (e) {
            notifyMessage = e.message ?? "update failed";
        } finally {
            // TODO: notify
            enqueueSnackbar(notifyMessage, { action: snackbarAction });
        }
    };

    const formik = useFormik({
        initialValues: createInitialValues(project),
        validationSchema,
        onSubmit: handleOnSubmit,
        enableReinitialize: true,
    });
    const { touched, errors, isSubmitting } = formik;

    // fetch form option.

    return (
        <>
            <FormikProvider value={formik}>
                <Form {...props}>
                    <Stack spacing={2}>
                        <FormControl fullWidth>
                            <FormLabel>Benefit</FormLabel>
                            <Field
                                component={OutlinedInput}
                                type="text"
                                name="benefit"
                                placeholder="Benefit"
                                multiline
                                minRows={3}
                            />
                            <FormHelperText name="benefit" touched={touched} errors={errors} />
                        </FormControl>

                        <Stack direction="row" spacing={1} sx={{ marginTop: 3 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                type="submit"
                                disabled={formik.isSubmitting || !formik.dirty}
                            >
                                Save
                            </Button>
                            <Button variant="outlined" type="reset" disabled={formik.isSubmitting || !formik.dirty}>
                                Cancel
                            </Button>
                        </Stack>
                    </Stack>
                </Form>
            </FormikProvider>
        </>
    );
}
